import { KitchenType } from '../domain/types';

export const kitchenTypeLabels: Record<KitchenType, string> = {
  [KitchenType.CUCINA]: 'Cucina abitabile',
  [KitchenType.ANGOLO_COTTURA]: 'Angolo cottura',
  [KitchenType.CUCINA_A_VISTA]: 'Cucina a vista',
  [KitchenType.CUCINA_SEMI_ABITABILE]: 'Cucina semi abitabile',
  [KitchenType.CUCINOTTO]: 'Cucinotto',
};
